import React, { useCallback, useEffect, useState } from "react";
import CmGap from "../Components/CmGap";
import MdHeading from "../Components/MdHeading";
import {
  allUsersFun,
  deleteUserFun,
  deleteUsers,
  fetchUserReports,
} from "../Toolkit/AllUsersSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import {
  Button,
  DatePicker,
  Flex,
  FloatButton,
  Input,
  Popconfirm,
  Typography,
  notification,
} from "antd";
import CreateUserNEditModal from "../Model/CreateUserNEditModal";
import { Icon } from "@iconify/react";
import CommonTable from "../Components/CommonTable";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import { formatFlexibleTime } from "../common";
const { Text } = Typography;
const { RangePicker } = DatePicker;

const AllUsers = () => {
  const dispatch = useDispatch();
  const { userId } = useParams();
  const { pathname } = useLocation();
  const { deleteUser, multiUserDeleteLoading, page } = useSelector(
    (prev) => prev?.alluser
  );
  const { allUsers } = useSelector((prev) => prev?.alluser);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [exportedData, setExportedData] = useState([]);

  useEffect(() => {
    setFilteredData(allUsers);
  }, [allUsers]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    const filtered = allUsers?.filter((item) =>
      Object.values(item)?.some((val) =>
        String(val)?.toLowerCase()?.includes(value?.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  useEffect(() => {
    dispatch(allUsersFun({ userId }));
  }, [dispatch, deleteUser, page]);

  const deleteExistUserFun = async (id) => {
    if (window.confirm("Are You Want to Sure ?")) {
      const delUser = await dispatch(deleteUsers([id]));
    }
  };

  const columns1 = [
    {
      title: "S.no",
      dataIndex: "id",
      key: "0",
      fixed: "left",
      width:80,
      render: (_, data,idx) => idx+1,
    },
    {
      title: "User name",
      dataIndex: "username",
      key: "1",
      fixed: "left",
      render: (_, data) => <Link to={`${data?.email}`}>{data?.username}</Link>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "2",
    },
    {
      title: "Created date",
      dataIndex: "createdAt",
      key: "3",
      render: (_, data) => (
        <Text>{new Date(data?.createdAt).toLocaleDateString()}</Text>
      ),
    },
    {
      title: "Role",
      dataIndex: "roles",
      key: "4",
    },
    {
      title: "Screenshot",
      dataIndex: "screenshot",
      key: "5",
      render: (_, data) => (
        <Link to={`screenshot/${data?.email}`}>
          <Button>screenshot</Button>
        </Link>
      ),
    },
    {
      title: "Gap",
      dataIndex: "gap",
      key: "6",
      render: (_, data) => (
        <Link to={`gap/${data?.email}`}>
          <Button size="small" type="primary">
            View
          </Button>
        </Link>
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "7",
      render: (_, data) => (
        <CreateUserNEditModal
          data={data}
          edit={true}
          modalTitle={"Edit user"}
        />
      ),
    },
    {
      title: "Delete",
      dataIndex: "delete",
      key: "8",
      render: (_, data) => (
        <Button
          danger
          size="small"
          type="text"
          onClick={() => deleteExistUserFun(data?.id)}
        >
          <Icon icon="fluent:delete-20-filled" />
        </Button>
      ),
    },
  ];

  const handleDeleteUser = useCallback(() => {
    dispatch(deleteUsers(selectedRows));
  }, [selectedRows, dispatch]);

  useEffect(() => {
    if (multiUserDeleteLoading === "success") {
      notification.success({
        message: "Users deleted successfully",
      });
      setSelectedRows([]);
      dispatch(allUsersFun());
    } else if (multiUserDeleteLoading === "rejected") {
      notification.error({
        message: "Something went wrong",
      });
    }
  }, [multiUserDeleteLoading]);

  console.log("allusersSelection", selectedRows);

  
  const headers = [
    "Id",
    "User name",
    "User email",
    "Date",
    "Login time",
    "Logout time",
    "Present",
    "Total time",
    "Day of week",
    "Attendance type",
    "Gap time",
    "Gap filled time",
    "Productive time"
  ];

  const handleFetchExportData = (values) => {
    let data = {
      requesterId: userId,
      startDate: dayjs(values?.[0]).format("YYYY-MM-DD"),
      endDate: dayjs(values?.[1]).format("YYYY-MM-DD"),
      userIds: selectedRows,
    };
    dispatch(fetchUserReports(data))
      .then((resp) => {
        if (resp.meta.requestStatus === "fulfilled") {
          console.log("djshsjgdsjsd", resp);
          const data = resp?.payload;
          const exportData = data?.map((row) => ({
            Id: row?.id,
            "User name": row?.userName,
            "User email": row?.userEmail,
            Date: row?.date,
            "Login time": formatFlexibleTime(row?.loginTime),
            "Logout time": formatFlexibleTime(row?.logoutTime),
            Present: row?.present,
            "Total time": row?.totalTime,
            "Day of week": row?.dayOfWeek,
            "Attendance type": row?.attendanceType,
            "Gap time": row?.gapTime,
            "Gap filled time": row?.gapFilledTime,
            "Productive time": row?.productiveTime,
          }));
          setExportedData(exportData);
        } else {
          setExportedData([]);
        }
      })
      .catch(() => setExportedData([]));
  };

  return (
    <CmGap>
      <div className="align-between">
        <MdHeading
          data={
            pathname === `/${userId}/workplus/users`
              ? `All Users Report (${allUsers?.length})`
              : pathname === `/${userId}/workplus/userlist`
              ? "All User List"
              : "All Users Screenshot"
          }
        />
      </div>
      <Flex
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: "4px 0px",
        }}
      >
        <Input
          value={searchText}
          onChange={handleSearch}
          placeholder="search"
          style={{ width: "25%" }}
        />
        <Flex gap={8}>
          {pathname === `/${userId}/workplus/users` && (
            <CreateUserNEditModal edit={false} modalTitle={"Create user"} />
          )}
        </Flex>
      </Flex>

      <CommonTable
        dataSource={filteredData}
        columns={columns1}
        rowSelection={true}
        selectedRowKeys={selectedRows}
        scroll={{ y: 500, x: 1500 }}
        onRowSelection={setSelectedRows}
      />

      {selectedRows?.length > 0 && (
        <FloatButton.Group
          shape="square"
          style={{
            right: '20vw',
            width: 550,
            padding: "12px",
            background: "rgba(0,0,0,0.7)",
            backgroundColor: "rgba(0,0,0,0.7)",
            boxShadow:
              "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(236, 208, 208, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;",
          }}
        >
          <Flex gap={16}>
            <Flex gap={4}>
              <RangePicker
                style={{ width: "100%" }}
                disabledDate={(current) =>
                  current && current > dayjs().endOf("day")
                }
                onChange={(e) => handleFetchExportData(e)}
              />

              <CSVLink
                className="text-white"
                data={exportedData}
                headers={headers}
                filename={"user_report.csv"}
                onClick={() => {
                  if (exportedData.length === 0) return false;
                  setTimeout(() => {
                    setExportedData([]);
                  }, 500);
                }}
              >
                <Button disabled={exportedData?.length === 0}>Export</Button>
              </CSVLink>
            </Flex>
            <Popconfirm
              description="Are you sure to delete users"
              onConfirm={handleDeleteUser}
            >
              <Button danger icon={<Icon icon="fluent:delete-20-filled" />}>
                Delete ({selectedRows?.length})
              </Button>
            </Popconfirm>
          </Flex>
        </FloatButton.Group>
      )}
    </CmGap>
  );
};

export default AllUsers;
